/* import __COLOCATED_TEMPLATE__ from './select-kit-collection.hbs'; */
var _obj;
function _applyDecoratedDescriptor(i, e, r, n, l) {
  var a = {};
  return Object.keys(n).forEach(function (i) {
    a[i] = n[i];
  }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) {
    return n(i, e, r) || r;
  }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a;
}
import "@glimmer/tracking";
let cached = esc(require('ember-cached-decorator-polyfill')).cached;
import Component, { setComponentTemplate } from "@ember/component";
import { action } from "@ember/object";
import { disableBodyScroll, enableBodyScroll } from "discourse/lib/body-scroll-lock";
import TEMPLATE from "./select-kit-collection.hbs";
import esc from "../../../../../../../../../../../../node_modules/@embroider/macros/src/addon/es-compat2";
export default setComponentTemplate(TEMPLATE, Component.extend((_obj = {
  tagName: "",
  get inModal() {
    const element = this.selectKit.mainElement();
    return element.closest(".d-modal");
  },
  lock(element) {
    if (!this.inModal) {
      return;
    }
    disableBodyScroll(element);
  },
  unlock(element) {
    enableBodyScroll(element);
  }
}, (_applyDecoratedDescriptor(_obj, "inModal", [cached], Object.getOwnPropertyDescriptor(_obj, "inModal"), _obj), _applyDecoratedDescriptor(_obj, "lock", [action], Object.getOwnPropertyDescriptor(_obj, "lock"), _obj), _applyDecoratedDescriptor(_obj, "unlock", [action], Object.getOwnPropertyDescriptor(_obj, "unlock"), _obj)), _obj)));